<template>
  <div id="pageDashboard">

  <!-- Atualização Cadastral -->

<v-dialog v-model="showModal" max-width="700">
      <v-card>
        <div class="validation-header" style="text-align: right; cursor:pointer; margin-bottom: -25px;">
          <i style="margin: 15px 15px 0 0; font-size: 24px;" class="fas fa-times" v-on:click="showModal = false"></i>
        </div>

        <v-card-title class="headline" style="text-align: center; display: block !important;">
          <b>Aviso de Manutenção Programada</b>
        </v-card-title>

        <v-card-text style="text-align: center; padding: 20px;">
          <p>Informamos que, devido a manutenção em nossa infraestrutura, <b>nossa plataforma poderá apresentar instabilidades a partir das 20h de hoje, 29/01, até as primeiras horas do dia 30/01.</b> Durante esse período, alguns serviços poderão ficar temporariamente indisponíveis.</p>
          <p style="margin-top: 20px;">Estamos trabalhando para aprimorar sua experiência, e agradecemos pela compreensão.</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex pb-0 xs12>
          <filter-row></filter-row>
        </v-flex>

        <v-flex sm12 xs12 pt-0>
          <v-layout row wrap>
            <v-flex sm12 xs12 md6 xs6>
              <commissions-card
                title="Comissões"
                color="#2962FF"
                :total="estimatedCommission"
                :reachedAmount="confirmedCommission"
                :cancelledAmount="lostCommission"
              ></commissions-card>
            </v-flex>

            <v-flex sm12 xs12 md6 xs6>
              <wallet-card
                title="Carteira"
                :reachedAmount="balance"
                :todayBalance="todayBalance"
                :waitingApproval="waitingApprovalCommission"
                :waitingConciliation="waitingConciliationCommission"
                color="#33c441"
                :button="true"
              ></wallet-card>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex sm12 xs12>
          <conversion-stats-card
            title="Estatísticas"
            color="#C54747"
            :needsRefresh="needsRefresh"
            :button="false"
            :clicks="clicks"
            :xaxis="period"
            :series="staticSeries"
            :approved="approveds"
            :signUpClients="signUpClients"
            :signUpApproved="signUpApproved"
          ></conversion-stats-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PageClass from "@consigmais-team/vue-common/layout/defaultPage/pageClass";
import MiniStatistic from "@consigmais-team/vue-common/components/widgets/statistic/MiniStatistic";
import VWidget from "@consigmais-team/vue-common/components/VWidget";
import Material from "vuetify/es5/util/colors";
import BoxChart from "@consigmais-team/vue-common/components/widgets/chart/BoxChart";
import FilterRow from "@consigmais-team/vue-common/layout/defaultPage/FilterRow";
import {
  StackData,
  SinData,
  monthVisitData,
  campaignData,
  locationData,
} from "@/api/chart";
import CardStatistic from "@consigmais-team/vue-common/components/widgets/statistic/CardStatistic";
import CardLinearStatistic from "@consigmais-team/vue-common/components/widgets/statistic/CardLinearStatistic";
import numeral from "numeral";
import moment from "moment";
import WalletCard from "../components/WalletCard";
import ConversionStatsCard from "../components/ConversionStatsCard";
import CommissionsCard from "../components/CommissionsCard";
import CampaignsCard from "../components/CampaignsCard";
import axios from "axios";

const defaultChartData = [
  {
    name: "Sem informações",
    value: 0,
  },
];

export default PageClass.extend({
  components: {
    FilterRow,
    VWidget,
    MiniStatistic,
    BoxChart,
    CardStatistic,
    CardLinearStatistic,
    WalletCard,
    ConversionStatsCard,
    CommissionsCard,
    CampaignsCard,
    CampaignsCard,
  },

  data() {
    return {
      showModal: false,
      loading: false,
      isLoading: false,
      walletId: null,
      balance: 0,
      todayBalance: 0,
      dateTo: null,
      dateFrom: null,
      needsRefresh: null,

      updateAffiliate: {
      afId: null,
      name: null,
      phone: null,
      federalId: null,
      corporateName: null,
      bank: null,
      agency: null,
      account: null,
    },

      //Parte 1
      reachedCommission: 0,
      cancelledCommission: "0",
      uniqueDownloads: 0,
      signUpClients: 0,
      signUpApproved: 0,
      clientWithProduction: 0,
      requestContracts: 0,
      inAnalysisContracts: 0,
      concludedContracts: 0,
      deniedContracts: 0,
      clicks: [],
      approveds: [],
      staticSeries: [],
      period: [],

      // COMMISSIONS
      estimatedCommission: 0,
      confirmedCommission: 0,
      lostCommission: 0,
      voidedCommission: 0,
      unconfirmedCommission: 0,
      waitingApprovalCommission: 0,
      availableCommission: 0,
      waitingConciliationCommission: 0,

      series: [
        {
          name: "Cliques",
          data: [],
        },
        {
          name: "Aprovados",
          data: [],
        },
      ],

      chartOptions: {
        theme: {
          mode: "light",
        },
        title: {
          text: "Cliques x Cadastros",
        },
        legend: {
          markers: {
            strokeColor: "#FFF",
          },
        },
        chart: {
          id: "clicksAndSignUp",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          sparkline: {
            enabled: false,
          },
          locales: [
            {
              name: "pt-br",
              options: {
                months: [
                  "Janeiro",
                  "Fevereiro",
                  "Março",
                  "Abril",
                  "Maio",
                  "Junho",
                  "Julho",
                  "Agosto",
                  "Setembro",
                  "Outubro",
                  "Novembro",
                  "Dezembro",
                ],
                shortMonths: [
                  "Jan",
                  "Fev",
                  "Mar",
                  "Abr",
                  "Mai",
                  "Jun",
                  "Jul",
                  "Ago",
                  "Set",
                  "Out",
                  "Nov",
                  "Dez",
                ],
                days: [
                  "Domingo",
                  "Segunda",
                  "Terça",
                  "Quarta",
                  "Quinta",
                  "Sexta",
                  "Sábado",
                ],
                shortDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
                toolbar: {
                  exportToSVG: "Download SVG",
                  exportToPNG: "Download PNG",
                  menu: "Menu",
                  selection: "Selection",
                  selectionZoom: "Selection Zoom",
                  zoomIn: "Zoom In",
                  zoomOut: "Zoom Out",
                  pan: "Panning",
                  reset: "Reset Zoom",
                },
              },
            },
          ],
          defaultLocale: "pt-br",
        },
        colors: ["#3F51B5", "#43A047"],
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        yaxis: {
          show: true,
        },
        xaxis: {
          categories: [],
          rotateAlways: false,
          hideOverlappingLabels: true,
          tooltip: {
            enabled: false,
          },
        },
      },

      commissionChartOptions: {
        theme: {
          mode: "light",
        },
        title: {
          text: "Comissões",
        },
        legend: {
          markers: {
            strokeColor: "#000",
          },
        },
        tooltip: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        chart: {
          id: "commissions",
          toolbar: {
            show: false,
          },
          sparkline: {
            enabled: false,
          },
          locales: [
            {
              name: "pt-br",
              options: {
                months: [
                  "Janeiro",
                  "Fevereiro",
                  "Março",
                  "Abril",
                  "Maio",
                  "Junho",
                  "Julho",
                  "Agosto",
                  "Setembro",
                  "Outubro",
                  "Novembro",
                  "Dezembro",
                ],
                shortMonths: [
                  "Jan",
                  "Fev",
                  "Mar",
                  "Abr",
                  "Mai",
                  "Jun",
                  "Jul",
                  "Ago",
                  "Set",
                  "Out",
                  "Nov",
                  "Dez",
                ],
                days: [
                  "Domingo",
                  "Segunda",
                  "Terça",
                  "Quarta",
                  "Quinta",
                  "Sexta",
                  "Sábado",
                ],
                shortDays: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
                toolbar: {
                  exportToSVG: "Download SVG",
                  exportToPNG: "Download PNG",
                  menu: "Menu",
                  selection: "Selection",
                  selectionZoom: "Selection Zoom",
                  zoomIn: "Zoom In",
                  zoomOut: "Zoom Out",
                  pan: "Panning",
                  reset: "Reset Zoom",
                },
              },
            },
          ],
          defaultLocale: "pt-br",
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return numeral(+value).format("$ 0,0.00");
            },
          },
          show: true,
        },
        xaxis: {
          type: "datetime",
          categories: [],
          rotateAlways: false,
          hideOverlappingLabels: true,
          tooltip: {
            enabled: false,
          },
        },
      },

      commissionSeries: [
        {
          name: "R$",
          data: [],
        },
      ],

      //Parte 2
      totalAffiliates: 0,
      newAffiliates: 0,
      affiliatesWithLeads: 0,
      affiliatesWithResult: 0,

      dataFilter: {},

      byComissions: false,
      perAmountType: defaultChartData,
      perCommissionType: defaultChartData,

      commissionsList: null,
      commissionCols: [
        {
          dataField: "commissionDate",
          caption: "Período",
          minWidth: 150,
        },
        {
          dataField: "productTypeName",
          caption: "Tipo de Produto",
          minWidth: 100,
        },
        {
          dataField: "covenantName",
          caption: "Convenio",
          minWidth: 100,
        },
        {
          dataField: "amount",
          caption: "Valor Contrato",
          dataType: "number",
          format: {
            type: "currency",
            precision: 2,
          },
          minWidth: 90,
        },
        {
          dataField: "term",
          caption: "Prazo",
          dataType: "number",
          minWidth: 90,
        },
        {
          dataField: "bankChartCode",
          caption: "Tabela",
          minWidth: 90,
        },
        {
          dataField: "totalCommission",
          caption: "Comissão",
          dataType: "number",
          format: {
            type: "currency",
            precision: 2,
          },
          minWidth: 90,
        },
      ],

      color: Material,
      dataset: {
        sinData: SinData,
        monthVisit: monthVisitData,
        campaign: campaignData,
        location: locationData,
        stackData: StackData,
      },
    };
  },

  computed: {
    chartType() {
      return this.commissions && this.commissions.length > 3 ? "area" : "bar";
    },
    isMaster() {
      return this.$uCan({ key: "subAfiliados" }) === 1;
    },
  },

  methods: {
    setRead(){
      this.showModal = false;
      localStorage.setItem("modalShown", "false");
    },
    async saveUpdateAff() {
    const { afId, name, phone, federalId, corporateName, bank, agency, account } = this.updateAffiliate;

    // Valida os campos obrigatórios
    if (!phone || !federalId || !corporateName || !bank || !agency || !account) {
      this.$notifyUser({
        message: 'O preenchimento de todos os campos é obrigatório.',
        type: 'error'
      });
      return;
    }

    this.isLoading = true;
    try {
      // Define o URL do endpoint
      const url = 'https://joqbduvvcppeeytsbxuw.supabase.co/rest/v1/updates';

      // Define os cabeçalhos da requisição
      const headers = {
        'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpvcWJkdXZ2Y3BwZWV5dHNieHV3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTY0MDc3MDYsImV4cCI6MjAzMTk4MzcwNn0.i3nZUxQhDmdxt8hny2UvX49b0dVCqJePiiEc7ja1Nu4',
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpvcWJkdXZ2Y3BwZWV5dHNieHV3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTY0MDc3MDYsImV4cCI6MjAzMTk4MzcwNn0.i3nZUxQhDmdxt8hny2UvX49b0dVCqJePiiEc7ja1Nu4',
        'Content-Type': 'application/json',
        'Prefer': 'return=minimal'
      };

      // Faz a chamada POST usando Axios
      const response = await axios.post(url, this.updateAffiliate, { headers });
      this.isLoading = false;
      this.setRead();

      this.$notifyUser({
        message: 'Informações registradas com sucesso. Obrigada!',
        type: 'success'
      });
    } catch (error) {
      console.error('Erro:', error);
      this.isLoading = false;
      this.$notifyUser({
        message: 'Ocorreu um erro ao registrar as informações.',
        type: 'error'
      });
    }
  },
    pageFiltersChange(filters) {
      this.dataFilter = {
        affiliateId: filters.affiliateId || null,
        productId: filters.productId || null,
        myLeads: filters.myLeads,
        sumType: filters.sumType,
        beginDate: filters.dateRange[0],
        endDate: filters.dateRange[1],
        campaignId: filters.campaignId || null,
      };
      this.loadData(this.dataFilter);
    },

    async loadData(filters) {
      this.needsRefresh = this.$store.getters.activePageFilters.dateRange;
      if (!filters) {
        let actualFilters = this.$store.getters.activePageFilters;
        filters = {
          affiliateId: actualFilters.affiliateId || null,
          productId: actualFilters.productId || null,
          myLeads: actualFilters.myLeads,
          sumType: actualFilters.sumType,
          beginDate: actualFilters.dateRange[0],
          endDate: actualFilters.dateRange[1],
          campaignId: actualFilters.campaignId || null,
        };
      }

      let data = await this.$api.dataService.execute(
        "dashboardAffiliate/getData",
        filters
      );
      // console.log(data);

      if (data) {
        //Parte 1
        this.reachedCommission = data.commissionReached;
        this.cancelledCommission = data.commissionCancelled.toString();
        this.uniqueDownloads = parseFloat(data.uniqueDownloads);
        this.signUpClients = parseFloat(data.signUpClients);
        this.signUpApproved = parseFloat(data.signUpApproved);
        this.clientWithProduction = parseFloat(data.clientWithProduction);
        this.requestContracts = parseFloat(data.requestContracts);
        this.inAnalysisContracts = parseFloat(data.inAnalysisContracts);
        this.concludedContracts = parseFloat(data.concludedContracts);
        this.deniedContracts = parseFloat(data.deniedContracts);
        this.clicks = data.clicksAndSignUpChartData.clicks;
        this.approveds = data.clicksAndSignUpChartData.approved;

        // COMMISSIONS
        this.estimatedCommission = parseFloat(data.estimatedCommission);
        this.confirmedCommission = parseFloat(data.confirmedCommission);
        this.lostCommission = parseFloat(data.lostCommission);
        this.voidedCommission = parseFloat(data.voidedCommission);
        this.unconfirmedCommission = parseFloat(data.unconfirmedCommission);
        this.waitingApprovalCommission = parseFloat(data.waitingApprovalCommission);
        this.availableCommission = parseFloat(data.availableCommission);
        this.waitingConciliationCommission = parseFloat(
          data.waitingConciliationCommission
        );

        (this.staticSeries = [
          {
            name: "Cliques",
            data: data.clicksAndSignUpChartData.clicks,
          },
          {
            name: "Aprovados",
            data: data.clicksAndSignUpChartData.approved,
          },
        ]),
          (this.period = data.commissionChartData.date);
        //Parte 2
        this.totalAffiliates = parseFloat(data.totalAffiliates);
        this.newAffiliates = parseFloat(data.newAffiliates);
        this.affiliatesWithLeads = parseFloat(data.affiliatesWithLeads);
        this.affiliatesWithResult = parseFloat(data.affiliatesWithResult);
      }
    },
  },

  async created() {
    if (!this.hasPageFilters) {
      this.createPageFilters([
        { field: "affiliateId" },
        { field: "myLeads" },
        { field: "productId" },
        { field: "sumType" },
        { field: "dateRange" },
        { field: "campaignId" },
      ]);

      // DEFAULTS FILTERS
      let endDate = this.$moment().format("YYYY-MM-DD");
      let beginDate = this.$moment().format("YYYY-MM-01");

      this.setPageFilter("affiliateId", null);
      this.setPageFilter("myLeads", false);
      this.setPageFilter("campaignId", null);
      this.setPageFilter("sumType", "daily", "Totalizado por Dia");
      this.setPageFilter(
        "dateRange",
        [beginDate, endDate],
        "Entre {0} e {1}".format(
          this.$moment(beginDate).format("DD/MM/YYYY"),
          this.$moment(endDate).format("DD/MM/YYYY")
        )
      );
    }
    this.loadData();
    let myWallets = await this.$api.dataService.execute("wallet/getMyWallets", {});
    if (myWallets && myWallets.length) {
      this.walletId = myWallets[0].id;
      let auxBalances = await this.$api.dataService.execute("wallet/getBalance", {
        walletId: this.walletId,
      });
      if (auxBalances) {
        this.balance = auxBalances.balance;
        this.todayBalance = auxBalances.todayBalance;
      }
    } else {
      //erro
      console.log("ERRO, não achou wallet");
    }

    

    //Pega dados do afiliados
    if (typeof localStorage !== 'undefined') {
    // Obtém o objeto do localStorage e converte para JSON
    const userDataJSON = localStorage.getItem('stCompany');
    
    if (userDataJSON) {
        // Converte o JSON de volta para um objeto JavaScript
        const userData = JSON.parse(userDataJSON);
        
        // Extrai o ID e o nome do usuário
        this.updateAffiliate.afId = userData.user.id;
        this.updateAffiliate.name = userData.user.name;
        
    } 

        // Verifica no localStorage se o modal já foi exibido
//         if (localStorage.getItem("modalShown") === 'false') {
//   this.showModal = false;
// } else {
//   this.showModal = true;
//}
}
  },
});
</script>

<style scoped>
#PageFooter {
  background-color: transparent !important;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.86),
    rgba(7, 12, 19, 0.93)
  ) !important;
  color: antiquewhite;
}
.v-card {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue